import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {AlertService} from "@app/_services";
import {ConfirmationService, MessageService, PrimeNGConfig} from "primeng/api";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {OrderProductService} from "@app/_components/order-product/order-product.service";
import {OrderDetail} from "@app/_components/reservation/components/reservation/order-detail/order-detail";
import {OwnerStmtService} from "@app/_components/owner-statements/owner-stmt.service";

@Component({
    selector: 'app-add-statement-detail',
    templateUrl: './add-statement-detail.component.html',
    styleUrls: ['./add-statement-detail.component.css'],
    standalone: false
})
export class AddStatementDetailComponent implements OnInit {
  statementDetail: any;
  shortTermRentalId: any;
  isUpdate = false;
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;
  orderProducts: any;
  reservation: any;
  ownerStmtExp: any;
  type: any;
  objToEdit: any;

  validationMessages = {
    'orderDetailId': [],
    'orderId': [],
    'orderProductId': [],
    'reservationId': [],
    'bedId': [],
    'quantity': [{ type: 'required', message: 'Required' }],
    'listPrice': [{ type: 'required', message: 'Required' }],
    'listPriceAdjustmentPercent': [],
    'listPriceAdjustmentAmount': [],
    'description': [],
    'privateNotes': [],
    'publicNotes': [],
    'changeLog': [],
    'guestNotes': [],
    'name': [{ type: 'required', message: 'Required' }],
    'amount': [{ type: 'required', message: 'Required' }],
    'salesTaxable': [],
    'roomTaxable': [],
    'serviceDate': []
  };
  constructor(
              private primengConfig: PrimeNGConfig,
              private orderProductService: OrderProductService,
              private alertService: AlertService,
              private messageService: MessageService,
              private confirmationService: ConfirmationService,
              private formBuilder: UntypedFormBuilder,
              private ownerStmtService: OwnerStmtService,
              @Inject(MAT_DIALOG_DATA) data: any) {
    this.formTitle = data.title;
    this.reservation = data.reservation;
    this.type = data.type;
    this.type = data.type;
    this.objToEdit = data.objToEdit;
    this.shortTermRentalId = data?.shortTermRentalId;
    this.isUpdate = false;
  }

  @Input() orderDetail: any;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  ngOnInit(): void {
    this.fetchOrderProducts();
    this.primengConfig.ripple = true;
    this.formBuild();
  }

  formBuild() {
    console.log(this.objToEdit);
    if(this.type === 'Reservation') {
      this.form1 = this.formBuilder.group({
        ownerStmtDetailId: [this.objToEdit ? this.objToEdit.ownerStmtDetailId : ''],
        orderId: [],
        orderProductId: [this.objToEdit ? this.objToEdit.orderProductId : ''],
        ownerStmtId: [this.reservation?.ownerStmtId],
        ownerStmtExpId: [],
        ownerStmtRezId: [this.reservation?.ownerStmtRezId],
        amount: [this.objToEdit ? this.objToEdit.amount : ''],
        quantity: [this.objToEdit ? this.objToEdit.quantity : '', Validators.required],
        description: [this.objToEdit ? this.objToEdit.description : ''],
        serviceDate: [],
        name: [this.objToEdit ? this.objToEdit.name : '']
      });
    } else if(this.type === 'Expense') {
      this.form1 = this.formBuilder.group({
        ownerStmtDetailId: [this.objToEdit ? this.objToEdit.ownerStmtDetailId : ''],
        orderId: [],
        orderProductId: [this.objToEdit ? this.objToEdit.orderProductId : ''],
        ownerStmtId: [this.reservation?.ownerStmtId],
        ownerStmtExpId: [this.reservation?.ownerStmtExpId],
        ownerStmtRezId: [],
        amount: [this.objToEdit ? this.objToEdit.amount : ''],
        quantity: [this.objToEdit ? this.objToEdit.quantity : '', Validators.required],
        description: [this.objToEdit ? this.objToEdit.description : ''],
        name: [this.objToEdit ? this.objToEdit.name : ''],
        serviceDate: [],
      });
    }

  }

  fetchOrderProducts() {
    if (!this.orderProducts || this.orderProducts === undefined || this.orderProducts.length < 1) {
      try {
        this.ownerStmtService.findStmtOrderProduct()
          .subscribe(
            res => {
              // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
              this.orderProducts = res.data.orderProducts;
            },
            err => {
              console.log('Feature-Update FAIL: ' + JSON.stringify(err));
              this.alertService.error(err);
            },
            () => { });
      } catch (error) {
        console.log('Form Invalid: ' + JSON.stringify(error));
        this.alertService.error(error);
      }
    }
    else {
      // console.log('properties are ' + this.properties);
      return (this.orderProducts);
    }
  }

  onProductSelect($event: any) {
    if(this.orderProducts){
      let filteredOrderProduct = this.orderProducts.filter(orderProduct =>
      {
        return orderProduct.orderProductId === this.form1.value?.orderProductId;
      });
      if(filteredOrderProduct.length > 0){
        let selectedOrderProduct = filteredOrderProduct[0];
        this.orderDetail.listPrice =  selectedOrderProduct.listPrice;
        this.orderDetail.description = selectedOrderProduct.description;
        this.form1.patchValue(this.orderDetail);
      }
    }
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log('property-add post: ' + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.ownerStmtService.add(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-add SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.orderDetail = res.data.orderDetail;
            this.doAdd.emit(res.data);
          },
          (err: any) => {
            console.log('orderDetail-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log('orderDetail: ' + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;

      this.ownerStmtService.update(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-update SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.orderDetail = res.data.orderDetail;
            this.doAdd.emit(res.data);
          },
          (err: any) => {
            console.log('property-update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  onFormDelete() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete Id# ' + this.objToEdit.ownerStmtDetailId + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.formDelete();
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
      }
    });
  }

  formDelete() {
    try {
      this.ownerStmtService.delete(this.objToEdit.ownerStmtDetailId)
        .subscribe(
          (res: any) => {
            console.log('orderDetail-delete SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.doAdd.emit(res.data);
          },
          (err: any) => {
            console.log('orderDetail-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      this.alertService.error(error);
    }
  }

}
